<template>
  <a-tag :color="colour">
    {{ text }}
  </a-tag>
</template>

<script>
export default {
  name: 'OrderStatusTag',
  props: {
    status: {
      type: String,
      default () {
        return ''
      },
    },
    text: {
      type: String,
      default () {
        return ''
      },
    },
  },
  computed: {
    colour () {
      if (this.status == null) return 'grey'
      switch (this.status.toLowerCase()) {
        case 'draft': return 'grey'
        case 'new': return 'green'
        case 'in_progress': return 'orange'
        case 'dispatched': return 'blue'
        case 'delivered' : return 'purple'
        case 'finished' : return 'black'
        case 'cancelled': return 'red'
        case 'declined': return 'red'
        default: return 'grey'
      }
    },
  },
}
</script>

<style scoped>

</style>
